import React, { useEffect, useState } from "react";
import {
  Box,
  VStack,
  Heading,
  AspectRatio,
  Text,
  Spinner,
  Button,
} from "@chakra-ui/react";
import { NavLink } from "react-router-dom";
import { getDashboardVideos } from "../../../../services/videoService";

const CategoryList = () => {
  const [videoData, setVideoData] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const result = await getDashboardVideos();
        if (result) {
          setVideoData(result);
        }
      } catch (error) {
        console.error("Error fetching videos:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchVideos();
  }, []);

  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <Spinner size="xl" color="white" />
      </Box>
    );
  }

  return (
    <VStack spacing={8} align="stretch" mt={7}>
      {Object.entries(videoData).map(([category, videos]) => (
        <Box key={category}>
          <Heading size="md" mb={4} color="white" dir="rtl">
            <Button
              as={NavLink}
              to={`/category/${encodeURIComponent(category)}`}
              variant="solid"
              colorScheme="teal"
              size="md"
              mb={4}
              justifyContent="center"
              dir="rtl"
              textAlign="center"
              width="100%"
            >
              {category.charAt(0).toUpperCase() + category.slice(1)}
            </Button>
          </Heading>

          <VStack spacing={4} align="stretch">
            {videos.slice(0, 2).map((video) => {
              let videoId = "";

              // Handle regular YouTube videos
              if (video.url.includes("watch?v=")) {
                videoId = video.url.split("watch?v=")[1].split("&")[0];
              }
              // Handle YouTube Shorts
              else if (video.url.includes("/shorts/")) {
                videoId = video.url.split("/shorts/")[1].split("?")[0];
              }

              const embedUrl = `https://www.youtube.com/embed/${videoId}`;

              return (
                <Box
                  key={video.videoId}
                  bg="white"
                  shadow="md"
                  borderRadius="md"
                  overflow="hidden"
                >
                  <Box p={2}>
                    <Text fontWeight="bold" fontSize="sm" dir="rtl">
                      {video.title}
                    </Text>
                  </Box>
                  <AspectRatio ratio={16 / 9}>
                    <iframe
                      src={embedUrl}
                      title={video.title}
                      allowFullScreen
                    />
                  </AspectRatio>
                </Box>
              );
            })}
          </VStack>
        </Box>
      ))}
    </VStack>
  );
};

export default CategoryList;
